<template>
  <transition name="modal">
    <div class="modal-mask" @click="close">
      <div class="modal-wrapper">
        <div class="modal modal-container" :class="dialogStyle" @click.stop="">
          <div v-if="header" class="modal-header">
            <slot name="header"> </slot>
          </div>
          <div class="modal-body">
            <slot name="body"> </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer"> </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  overflowScrollTop,
  overflowAutoScrollTop,
} from "@/utils/modal_scroll_overflow.js";

export default {
  name: "Modal",
  props: {
    dialogStyle: String,
    header: {
      type: Boolean,
      required: false,
    },
  },
  emits: ["close"],
  setup(props, { emit }) {
    const close = () => {
      enableBodyScroll();
      emit("close");
    };
    overflowScrollTop();
    return {
      close,
    };
  },
  beforeUnmount() {
    overflowAutoScrollTop();
  },
};
</script>
